const regionDisplayOptions = [
  { value: 'state', label: 'States' },
  { value: 'zip3', label: 'State + Zip 3' },
]

export default regionDisplayOptions
